import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroQuoteForm.XeroQuoteFieldsSection', {
    customerFieldTitle: 'Customer',
    customerFieldPlaceholder: 'Choose customer',
    dateFieldTitle: 'Date',
    dateFieldPlaceholder: 'Enter date',
    expiryDateFieldTitle: 'Expiry',
    expiryDateFieldPlaceholder: 'Enter date',
    referenceFieldTitle: 'Reference',
    referenceFieldPlaceholder: 'Enter reference',
    quoteNumberFieldTitle: 'Quote number',
    quoteNumberFieldPlaceholder: 'Enter quote number',
    themeFieldTitle: 'Theme',
    themeFieldPlaceholder: 'Choose theme',
    addCustomerButton: '+ New Customer',
});
